import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ssApiService } from '../../../services/ss-api.service';
import { InvoiceArray, Invoice } from '../../../models/domain/invoice';
import { DialogService, DialogOptions } from '../../../services/modal-dialogs';
import { InvoiceDetailsDialog } from '../../../dialogs/invoice.details/invoice.details.dialog';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { MakePaymentDialog } from '../../../dialogs/make.payment/make.payment.dialog';
import { LicenseManager } from '../../../managers/License.manager';
import { AddInvoiceDialog } from '../../../dialogs/add.invoice/add.invoice.dialog';
import { UserRolesService } from '../../../services/user.roles.service';
import { SortBot } from '../../../../app/helpers/sort';
import { MemberDashboard } from '../../../../app/models/ss-api/responses/member.dashboard.response';

@Component({
    selector: 'member-invoices',
    templateUrl: './member.invoices.component.html',
    styleUrls: ['./member.invoices.component.css']
})
export class MemberInvoicesComponent implements OnInit {
    invoiceSearch: string;
    invoiceResultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    @Input('IsBusy') IsBusy: boolean;
    @Input('Invoices') Invoices: InvoiceArray;
    @Input('MemberID') MemberID: number;
    @Input('MemberName') MemberName: string = '';
    @Input('DashboardData') DashboardData: MemberDashboard;
    @Output('onRefresh') onRefresh: EventEmitter<string> = new EventEmitter();

    constructor(private api: ssApiService, private dialogService: DialogService, private sweetAlertService: SweetAlertService, public roles: UserRolesService) { }

    ngOnInit() {

    }

    // SORT
    sortByDate() { this.Invoices = SortBot.SortAuto<InvoiceArray>(this.Invoices, 'DateTimeCreated'); }
    sortByProduct() { this.Invoices = SortBot.SortAuto<InvoiceArray>(this.Invoices, 'Items', 'Description'); }
    sortByStatus() { this.Invoices = SortBot.SortAuto<InvoiceArray>(this.Invoices, 'Status'); }
    sortByNumber() { this.Invoices = SortBot.SortAuto<InvoiceArray>(this.Invoices, 'InvoiceNumber'); }
    sortByLicenseKey() { this.Invoices = SortBot.SortAuto<InvoiceArray>(this.Invoices, 'LicenseKey'); }
    sortBySubTotal() { this.Invoices = SortBot.SortAuto<InvoiceArray>(this.Invoices, 'SubTotal'); }
    sortByCredit() { this.Invoices = SortBot.SortAuto<InvoiceArray>(this.Invoices, 'Credit'); }
    sortByTotal() { this.Invoices = SortBot.SortAuto<InvoiceArray>(this.Invoices, 'TotalPaid'); }
    sortByTaxes() { this.Invoices = SortBot.SortAuto<InvoiceArray>(this.Invoices, 'CustomTaxAmount'); }

    onLicenseClick(license: string) {
        this.IsBusy = true;
        let manager = new LicenseManager()
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(license, true);
        manager.OnChangesSaveResponse.subscribe(response => {
            this.onRefresh.emit('');
        })
    }


    ShowAddInvoice() {
        let options: DialogOptions = { height: 700 }
        let disposable = this.dialogService.addDialog(AddInvoiceDialog, {
            title: 'Add New',
            subTitle: 'Add Invoice',
            IsEditDialog: false,
            Invoice: null,
            message: 'Confirm message',
            MemberID: this.MemberID,
            DashboardData: this.DashboardData
        }, options).subscribe(response => {
            disposable.unsubscribe();
            this.refreshInvoices();
        }, error => {
            disposable.unsubscribe();
        });
    }

    ShowEditInvoice(Item) {
        let options: DialogOptions = { height: 600 }

        let disposable = this.dialogService.addDialog(AddInvoiceDialog, {
            IsEditDialog: true,
            Invoice: Item,
            title: 'Edit',
            subTitle: 'Edit Invoice',
            message: 'Confirm message',
            MemberID: this.MemberID,
            DashboardData: this.DashboardData
        }, options).subscribe(response => {
            disposable.unsubscribe();
            this.refreshInvoices();
        }, error => {
            disposable.unsubscribe();
        });
    }

    ShowInvoiceDetails(Item) {
        let options: DialogOptions = { height: 650, width: 1200 };

        let disposable = this.dialogService.addDialog(InvoiceDetailsDialog, {
            title: 'Add New',
            message: 'Confirm message',
            invoiceItem: Item,
            memberName: this.MemberName
        }, options).subscribe(response => {
            disposable.unsubscribe();
            this.refreshInvoices();
        }, error => {
            disposable.unsubscribe();
        });
    }

    MakePayment(Item: Invoice) {
        let disposable = this.dialogService.addDialog(MakePaymentDialog, {
            title: 'Add New',
            message: 'Confirm message',
            subTitle: Item.InvoiceNumber,
            invoiceItem: Item,
            creditAmount: this.DashboardData.Credit
        }).subscribe(response => {
            disposable.unsubscribe();
            this.refreshInvoices();
        }, error => {
            disposable.unsubscribe();
        });
    }

    async DeleteInvoice(Item: Invoice) {
        this.IsBusy = true;

        // confirm
        await this.sweetAlertService.swal(
            {
                title: 'Delete Invoice?',
                text: 'Are you really sure you want to do this?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Do it!',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.api.DeleteInvoices(Item.InvoiceID.toString()).toPromise()
                }
            }).then(response => {

                this.IsBusy = false;

                if (!response.Result) {

                    this.sweetAlertService.swal(
                        {
                            title: 'Error',
                            text: response.Data,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true
                        })
                        .then(response => { })
                        .catch(error => { });

                    return;
                }

                // ok
                this.refreshInvoices();

                this.sweetAlertService.swal(
                    {
                        title: 'Success',
                        text: 'The invoice is deleted.',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then(response => { })
                    .catch(error => { });


            }, (dismiss) => {
                this.IsBusy = false;
                return;
            }); // keep this line to prevent promise error;

    }

    async AddTaxInvoice(Item: Invoice) {
        this.IsBusy = true;

        // confirm
        await this.sweetAlertService.swal(
            {
                title: 'Add Tax Invoice?',
                text: 'Are you really sure you want to do this?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Do it!',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.api.AddTaxInvoice(Item.InvoiceID).toPromise()
                }
            }).then(response => {

                this.IsBusy = false;

                if (!response.Result) {

                    this.sweetAlertService.swal(
                        {
                            title: 'Error',
                            text: response.Data,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true
                        })
                        .then(response => { })
                        .catch(error => { });

                    return;
                }

                // ok
                this.refreshInvoices();

                this.sweetAlertService.swal(
                    {
                        title: 'Success',
                        text: 'The invoice is created.',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then(response => { })
                    .catch(error => { });


            }, (dismiss) => {
                this.IsBusy = false;
                return;
            }); // keep this line to prevent promise error;

    }

    async RemoveTaxInvoice(Item: Invoice) {
        this.IsBusy = true;

        // confirm
        await this.sweetAlertService.swal(
            {
                title: 'Remove Tax Invoice?',
                text: 'Are you really sure you want to do this?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Do it!',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.api.RemoveTaxInvoice(Item.InvoiceID).toPromise()
                }
            }).then(response => {

                this.IsBusy = false;

                if (!response.Result) {

                    this.sweetAlertService.swal(
                        {
                            title: 'Error',
                            text: response.Data,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true
                        })
                        .then(response => { })
                        .catch(error => { });

                    return;
                }

                // ok
                this.refreshInvoices();

                this.sweetAlertService.swal(
                    {
                        title: 'Success',
                        text: 'The invoice is removed.',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then(response => { })
                    .catch(error => { });


            }, (dismiss) => {
                this.IsBusy = false;
                return;
            }); // keep this line to prevent promise error;

    }

    refreshInvoices() {
        this.onRefresh.emit('');
    }

    paginateInvoices(e) {
        // console.log("paginateSearch :", e);
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

    // Caculate Total Paid minus Amount refunded
    GetTotal(item: Invoice): number {
        return item.TotalPaid - item.TotalRefunded;
    }


}
